<template>
    <div>
        <Spin size="large" fix v-if="spinShow"></Spin>
        <!-- {{ data }} -->
        <Tabs value="1">
            <TabPane label="基础信息" name="1">
                <Form label-position="left" :label-width="80" >
                    <FormItem label="id" v-if="data.id">
                        <Input v-model="data.id"  disabled></Input>
                    </FormItem>
                    <!-- <FormItem label="游戏">
                        <Row>
                            <Col span="20" >
                                {{ $conf.games.games[data.game_id].name }}
                            </Col>
                        </Row>
                    </FormItem> -->
                    <FormItem label="英雄" v-if="$unit.filterGameids( [3,], game_id )">
                        <Row>
                            <Col span="20" >
                                <heroSearch v-model="data.hero" :game_id="game_id" ></heroSearch>
                            </Col>
                        </Row>
                    </FormItem>
                    <FormItem label="号位" v-if="$unit.filterGameids( [3,], game_id )" >
                        <Row>
                            <Col span="20" >
                                <Select v-model="data.number">
                                    <Option v-for="(item, index) in $conf.games.positions[game_id]" :value="item.id" :key="item.id">{{item.name}}</Option>
                                </Select>
                            </Col>
                        </Row>
                    </FormItem>

                    
                    <FormItem label="中文名称">
                        <Row>
                            <Col span="20" >
                                <Input v-model="data.name_zh" ></Input>
                            </Col>
                        </Row>
                    </FormItem>
                    <FormItem label="英文名称">
                        <Row>
                            <Col span="20" >
                                <Input v-model="data.name_en" ></Input>
                            </Col>
                        </Row>
                    </FormItem>

                    <FormItem label="中文描述">
                        <Row>
                            <Col span="20" >
                                <Input v-model="data.description_zh" type="textarea" ></Input>
                            </Col>
                        </Row>
                    </FormItem>

                    <FormItem label="英文描述">
                        <Row>
                            <Col span="20" >
                                <Input v-model="data.description_en" type="textarea"></Input>
                            </Col>
                        </Row>
                    </FormItem>

                    <FormItem label="logo: ">
                        <Row>
                            <imgEditor v-model="data.logo" :prefix="$conf.games.img_prefix" :dir="$conf.games.games[game_id].img + '/facet' "  
                                :previewButton='true' :clearButton='true' cdn='games'>
                            </imgEditor>
                        </Row>
                    </FormItem>

                    <FormItem label="颜色" >
                        <Row>
                            <Col span="20" >
                                <colorsDragable v-model="data.colors"></colorsDragable>
                            </Col>
                        </Row>
                    </FormItem>

                    <FormItem label="删除">
                        <Row>
                            <Col span="20" >
                                <Select v-model="data.deleted" >
                                    <Option :value="1" key="1">是</Option>
                                    <Option :value="0" key="0">否</Option>
                                </Select>
                            </Col>
                        </Row>
                    </FormItem>
                </Form>
            </TabPane>
        </Tabs>

        <Row :gutter="16" align="middle">
            <Col span="12" style="text-align: left" >
                <Button type="default"  @click="cancle" long size="default">取消</Button>
            </Col>
            <Col span="12" style="text-align: right">
                <Button type="primary"  @click="save" long size="default">保存</Button>
            </Col>
        </Row>
    </div>
</template>
<script>

import { FacetList, EditFacet } from '@/api/games/facet';
import imgEditor from '@/components/img-editor/img-editor.vue';
import heroSearch from '../hero/search.vue';
import colorsDragable from '../base/colors_dragable.vue';

export default {
    name: "tournament-edit",
    props: {
        game_id: Number,   // 运动id
        _id: Number,   // 比赛id
    },
    components: {
        imgEditor,
        heroSearch,
        colorsDragable,
    },
    data () {
        let self = (window.x = this)
        return {
            obj_type: 12,
            type: 5, 
            spinShow: false,
            data: {
                game_id: self.game_id,
                country: {},
            },
            locks: {},
        }
    },
    methods: {
        _init_data(){
            this.data = {
                game_id: this.game_id,
            }
        },
        // 获取比赛的基础数据
        getData () {
            let self = this;
            this.spinShow = true;
            // 搜索日期
            if (self._id > 0){
                var params = {
                    game_id: self.game_id,
                    id: self._id,
                }
                FacetList(params).then(response => {
                    // console.log(response)
                    if (response.data.code == 0) {
                        if (response.data.data.list && response.data.data.list.length > 0){
                            this.data = response.data.data.list[0];
                            // self.locks = response.data.data.locks;
                        }else{
                            this.data = {}
                        }
                    } else {
                        self.$Message.error(response.data.msg)
                    }
                })
            }else{
                self._init_data();
            }
            self.spinShow = false;
        },
        // end 
        emit(func_name){
            this.$emit('closePage', func_name)
        },

        cancle(){
            let self = this;
            self.emit("cancle")
        },
        save() {
            let self = this;
            var params = {
                id: self.data.id,
                game_id: self.data.game_id || self.game_id,
                hero_id: self.data.hero? self.data.hero['id']: 0,
                number: self.data.number,
                name_en: self.data.name_en,
                name_zh: self.data.name_zh,
                description_en: self.data.description_en,
                description_zh: self.data.description_zh,
                logo: self.data.logo,
                colors: self.data.colors,
                deleted: self.data.deleted,
            };
            // console.log(params);
            EditFacet(params).then(response => {
                if (response.data.code == 0) {
                    this.$Message.success("保存成功")
                    self.emit("save")
                } else {
                    self.$Message.error(response.data.msg)
                }
            })
        },
    },
    mounted () {
    },
    watch: {
        '_id': {
            handler(value){
                let self = this;
                if (value >= 0){
                    // console.log("Detail Get Data", value);
                    self.getData();
                };
            },
            deep: false,
	        immediate: false,  // 深度触发
        },
        // end 
    },
    computed: {
    }
}
</script>

<style scoped>
    /* @import "detail.css" */
</style>